export default "__VITE_ASSET__CcbD5wkn__"